import { useDroppable } from '@dnd-kit/core';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { WebsiteInfo } from '../utils/formatWebsiteInfo';
import * as S from './SourcesDraggableArea.styles';
import { WebsiteCard } from './WebsiteCard';

export const MAX_CUSTOM_SOURCES = 50;
const QUICK_ANSWER_SOURCES_LIMIT = 20;
const AREA_ID = 'sources-draggable-area';

interface DroppableAreaProps {
  items: WebsiteInfo[];
  handleRemove: (id: string) => void;
}

export const DroppableArea = ({ items, handleRemove }: DroppableAreaProps) => {
  const { t } = useTranslation(['chat']);

  const { setNodeRef } = useDroppable({ id: AREA_ID });

  const sourcesContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sourcesContainerRef.current && items.length) {
      sourcesContainerRef.current.scrollTop =
        sourcesContainerRef.current.scrollHeight;
    }
  }, [items.length]);

  return (
    <div id={AREA_ID} ref={setNodeRef}>
      <S.SourcesHeader>
        {t('chat:trustedSources.modal.tenSourcesHeader', {
          count: items.slice(0, QUICK_ANSWER_SOURCES_LIMIT).length,
        })}
      </S.SourcesHeader>
      <S.SourcesList ref={sourcesContainerRef}>
        {items.slice(0, QUICK_ANSWER_SOURCES_LIMIT).map(website => (
          <WebsiteCard
            key={website.id}
            {...website}
            handleRemove={handleRemove}
          />
        ))}
        <S.StickySourcesHeader
          isLast={items.length <= QUICK_ANSWER_SOURCES_LIMIT}
        >
          {t('chat:trustedSources.modal.upToTwentySourcesHeader', {
            count: items.slice(QUICK_ANSWER_SOURCES_LIMIT).length,
          })}
        </S.StickySourcesHeader>
        {items.slice(QUICK_ANSWER_SOURCES_LIMIT).map(website => (
          <WebsiteCard
            key={website.id}
            {...website}
            handleRemove={handleRemove}
          />
        ))}
      </S.SourcesList>
    </div>
  );
};
